import { ensureExhaustive } from "@b2bportal/core-utilities";
import { type ListingAddress, ListingAddressEnum } from "@b2bportal/homes-api";
import {
  type LodgingAddress,
  LodgingAddressEnum,
  type LodgingData,
} from "@b2bportal/lodging-api";

export const getAddressText = (
  address: LodgingAddress | ListingAddress
): string | null => {
  if ("LodgingAddress" in address) {
    switch (address.LodgingAddress) {
      case LodgingAddressEnum.Exact:
        return address.line1;
      case LodgingAddressEnum.Obfuscated:
        return address.city;
      default:
        return ensureExhaustive(address);
    }
  }

  if ("ListingAddress" in address) {
    switch (address.ListingAddress) {
      case ListingAddressEnum.Empty:
        return null;
      case ListingAddressEnum.ObfuscatedAddress:
        return `${address.city}, ${address.state}, ${address.countryCode}`;
    }
  }
};

/**
 * Destination name for the confirmation-screen flight cross-sell (RBC-2305):
 * the lodging city, from the obfuscated address or the top-level lodging
 * data. Returns undefined when no city resolves so callers can render
 * generic copy instead of "Book a flight to ".
 */
export const getCrossSellDestination = (
  lodgingData: Partial<Pick<LodgingData, "address" | "city">> | undefined
): string | undefined => {
  const addressCity =
    lodgingData?.address?.LodgingAddress === LodgingAddressEnum.Obfuscated
      ? lodgingData.address.city
      : undefined;
  return addressCity?.trim() || lodgingData?.city?.trim() || undefined;
};
